export default __webpack_public_path__ + "static/forumbiz-235d1acdf4ee2e64071164ff07da4528.png";